import clsx from 'clsx';
import type { FC } from 'react';

import { formatPhoneNumber } from 'utils';

import { LogoKassa } from '../logo-kassa';

import { FooterConfig } from './constants';

const Footer: FC = () => {
  return (
    <footer
      className={clsx(
        'hidden min-h-0 gap-16 justify-self-end text-sm text-white md:flex md:flex-row',
      )}
    >
      <LogoKassa />

      <div className="flex flex-row items-center gap-6">
        {FooterConfig.PAYMENT_IMAGES.map((image) => (
          <img key={image.alt} {...image} alt={image.alt} />
        ))}
      </div>

      <div className="flex shrink-0 flex-row items-center gap-2.5">
        <ul className="flex flex-col">
          {FooterConfig.SUPPORT_EMAIL.map((email) => (
            <li key={email}>
              <a href={`mailto:${email}`}>{email}</a>
            </li>
          ))}
        </ul>
        <div className="h-8 w-0.5 bg-white" />
        <a href={`tel:${FooterConfig.SUPPORT_PHONE}`}>
          {formatPhoneNumber(FooterConfig.SUPPORT_PHONE)}
        </a>
      </div>
    </footer>
  );
};

export { Footer };
